export interface IPreloadOptions {
  /**
   * Delay before starting preload (ms). Default: 2000ms
   * Allows the app to stabilize before preloading begins
   */
  delayMs?: number;

  /**
   * Callback when preload starts
   */
  onStart?: (count: number) => void;

  /**
   * Callback when preload completes
   */
  onComplete?: (result: { cached: number; failed: number }) => void;

  /**
   * Callback when preload errors
   */
  onError?: (error: Error) => void;
}

export function generateThumbnailUrl(imgSrc?: string): string | undefined {
  if (!imgSrc) {
    return undefined;
  }
  const url = new URL(imgSrc);
  url.searchParams.set('width', '360');
  return url.toString();
}
